export const translations = {
    tr: {
        back:"Geri",
        heroTitle: "MartTech: Perakende için Şüpheli İşlem Analizi",
        heroDesc: "Gerçek zamanlı fiş analizi, anında uyarı sistemi ve esnek kural motoru ile perakende sektörüne yeni bir çağ getiriyoruz.",
        cta: "Demo Talep Et",
        featuresTitle: "Özellikler",
        features: [
            { title: "PoS risklerini azaltma", desc: "Gerçek zamanlı veri işleme altyapısı" },
            { title: "Daha Kârlı Servis Tezgahları", desc: "Hızlı işlem değerlendirme yetenekleri" },
            { title: "Iptal Risklerinin Azaltılması", desc: "Beklenmedik iptallerinden kaynaklanan kayıpları güvenilir bir şekilde yönetilmesi" },
            { title: "Iade sürecinin uçtan uca izlenmesi", desc: "Bulut tabanlı ölçeklenebilir mimari" },
        ],
        howItWorksTitle: "Avantajlar",
        steps: [
            { title: "Tek Platform", desc: "Birden fazla çözüm yerine tek bir platforma erişerek zamandan tasarruf edin" },
            { title: "Kullanıcı Dostu", desc: "Egitimi ve kullanimi kolay" },
            { title: "Tam Kontrol", desc: "Stok sıkıntısını en çok etkileyen nedenleri ortaya çıkararak kayıpları azaltın" },
        ],
        testimonialQuote: "MartTech ile dolandırıcılık faaliyetlerinin tespit edilme süresi 60+ günden ortalama 5 güne kadar önemli ölçüde azaldı.",
        testimonialQuote2: "Kolay anlaşılır kullanıcı arayüzü yeni kullanıcıların eğitimini kolaylaştırıyor.",

        footerCopyright: "Tüm hakları saklıdır.",
        footerPrivacy: "Gizlilik Politikası",
        footerTerms: "Kullanım Şartları",
        footerContact: "İletişim",
        contact:{
            title: 'İletişim',
            description: 'Aşağıdaki formu doldurarak bizimle iletişime geçebilirsiniz.',
            name: 'Adınız',
            email: 'E-posta',
            message: 'Mesajınız',
            send: 'Gönder',
            success: 'Mesajınız başarıyla gönderildi!'
        },
        privacy: {
          title: 'Gizlilik Politikası',
          description: 'Bu web sitesi, size en iyi deneyim sağlamak için tanımlı bir gizlilik politikası kullanır.',
        },
        terms:{
            title: 'Kullanım Şartları',
            description: 'Bu web sitesini kullanarak aşağıdaki şartları kabul etmiş olursunuz. Lütfen dikkatlice okuyunuz.',
        }
    },
    en: {
        "back":"Back",
        heroTitle: "MartTech: Fraud Detection for Retail",
        heroDesc: "Bringing a new era to the retail sector with real-time receipt analysis, instant alerting, and customizable rule engine.",
        cta: "Request a Demo",
        featuresTitle: "Features",
        features: [
            { title: "PoS risk mitigation”", desc: "Real-time data ingestion pipeline" },
            { title: "More Profitable Service Counters", desc: "Fast process evaluation cache" },
            { title: "Reducing Cancellation Risks", desc: "Instant analytics on receipt data" },
            { title: "End-to-end monitoring of the refund process", desc: "Cloud-native scalable infrastructure" },
        ],
        howItWorksTitle: "Benefits",
        steps: [
            { title: "Single Platform", desc: "Save time by accessing a single platform instead of multiple solutions" },
            { title: "Easy to Use", desc: "Easy to train and use" },
            { title: "Full Control", desc: "Reduce losses by uncovering the top causes of stock shortages" },
        ],
        contact:{
            title: 'Contact',
            description: 'You can reach us by filling out the form below.',
            name: 'Your Name',
            email: 'Email',
            message: 'Your Message',
            send: 'Send',
            success: 'Your message was sent successfully!'
        },
        terms:{
          title: 'Terms of Conditions',
          description: 'By using this website, you agree to the following terms. Please read carefully.',
        },
        privacy:{
          title: 'Privacy Policy',
          description: 'This website uses cookies to ensure you get the best experience on our website.',
        },
        testimonialQuote: "MartTech helped us detect fraud across our retail chain, providing immediate savings.",
        testimonialQuote2: "An intuitive user interface simplifies the training of new users.",
        footerCopyright: "All rights reserved.",
        footerPrivacy: "Privacy Policy",
        footerTerms: "Terms of Service",
        footerContact: "Contact"
    }
};